export default "__VITE_ASSET__5cDyX7RE__"